import _ from 'lodash';

import {
  FIELDS_FIELD_TYPE,
  FIELDS_FIELD_TYPE_LABEL,
  FIELDS_RESOLVER_TYPE,
  FIELDS_VALIDATE_AGAINST_LABEL,
  RELATIONS_RELATION_TYPE,
  RELATIONS_RELATION_TYPE_LABEL,
  RESOLVED_FIELDS_TARGET,
  RESOLVED_FIELDS_TARGET_NAME,
} from '../constants/entity-designer.constants';

export const getMappedFilter = ({ accessor, filters }) => {
  switch (accessor) {
    case FIELDS_FIELD_TYPE_LABEL:
      return { ...filters, [FIELDS_FIELD_TYPE_LABEL]: filters[FIELDS_FIELD_TYPE] };
    case FIELDS_VALIDATE_AGAINST_LABEL:
      return { ...filters, [FIELDS_VALIDATE_AGAINST_LABEL]: filters[FIELDS_RESOLVER_TYPE] };
    case RESOLVED_FIELDS_TARGET_NAME:
      return { ...filters, [RESOLVED_FIELDS_TARGET_NAME]: filters[RESOLVED_FIELDS_TARGET] };
    case RELATIONS_RELATION_TYPE_LABEL:
      return { ...filters, [RELATIONS_RELATION_TYPE_LABEL]: filters[RELATIONS_RELATION_TYPE] };
    default:
      return filters;
  }
};

export const customStringSearchFilter = (accessor) => (row, filters) => {
  const _filter = getMappedFilter({ accessor, filters });

  const rowVal = (row?.[accessor] ?? '').toUpperCase();
  const filterVal = (_filter?.[accessor] ?? '').toUpperCase();

  return rowVal?.includes(filterVal);
};

export const customBooleanSearchFilter = (accessor) => (row, filters) => {
  const rowVal = row?.[accessor] ?? '';
  const filterVal = filters?.[accessor] ?? '';

  return _.isBoolean(filterVal) && _.isBoolean(rowVal) ? rowVal === filterVal : true;
};
